import React from "react";
import T from "prop-types";
import { Col } from "react-bootstrap";
import _ from "lodash";

import { AgnosticLoader } from "MODULES/shared/containers";
import { dataManager } from "MODULES/shared/decorators";
import api from "APP_ROOT/api";
import {
  DataTable,
  CompanyName,
  Warning
} from "MODULES/shared/components/index";
import { SUCCESS } from "LIB/submission/constants";
import { CheckGroup, FormRow } from "MODULES/shared/components/Forms";
import { API_BASE, CODE } from "APP_ROOT/constants";
import { withRouter } from "react-router";

class Form extends React.Component {
  static propTypes = {
    close: T.func.required,
    salesItem: T.shape({}),
    salesOrder: T.instanceOf(Map)
  };

  state = {
    inventory: {
      purchase_order_line_items: [],
      repair_order_line_items: [],
      sales_order_line_items: []
    },
    mergeItems: false,
    obtainedFrom: { text: null },
    sellersContractNumber: this.props.salesOrder.get(CODE)
  };

  onItemSelected = (item, type) => {
    item.type = type;
    item.text = null;
    this.setState({ obtainedFrom: item });

    this.resetOtherInput();
  };

  onFlatItemSelected = () => {
    this.setState({ obtainedFrom: { type: "other", text: null } });

    this.resetOtherInput();
  };

  onSellersContractUpdated = event => {
    this.setState({ sellersContractNumber: event.target.value });
  };

  onObtainedFromOther = event => {
    const value = event.target.value;

    this.setState(state => ({
      obtainedFrom: {
        ...state.obtainedFrom,
        text: value
      }
    }));
  };

  resetOtherInput = () => {
    if (this.otherInput) {
      this.otherInput.value = "";
    }
  };

  fetch = id =>
    api.inventories.show(id, "all", "reference_record_details").then(resp => {
      this.setState({ inventory: resp.data });

      return SUCCESS;
    });

  radioSelect = (item, type) => (
    <input
      type="radio"
      name="obtained_from_id"
      className="radio-inline"
      checked={this.state.obtainedFrom.id === item.id}
      onChange={() => this.onItemSelected(item, type)}
    />
  );

  inputRef = el => {
    this.otherInput = el;
  };

  renderCompanyLink = item => (
    <div>
      <CompanyName flattenedCompany={item} />
    </div>
  );

  renderPORow = item => (
    <tr key={`po-${item.id}`}>
      <td />
      <td className="text-center">
        {this.radioSelect(item, "purchase_order_line_item")}
      </td>
      <td>{_.get(item, "purchase_order.code")}</td>
      <td>
        <CompanyName company={item.company} />
      </td>
    </tr>
  );

  renderSORow = item => (
    <tr key={`so-${item.id}`}>
      <td />
      <td className="text-center">
        {this.radioSelect(item, "sales_order_line_item")}
      </td>
      <td>{item.sales_order_code}</td>
      <td>{this.renderCompanyLink(item)}</td>
    </tr>
  );

  renderRORow = item => (
    <tr key={`ro-${item.id}`}>
      <td />
      <td className="text-center">
        {this.radioSelect(item, "repair_order_line_item")}
      </td>
      <td>{item.repair_order_code}</td>
      <td>{this.renderCompanyLink(item)}</td>
    </tr>
  );

  render() {
    if (this.props.loading) return null;

    const {
      permissions: {
        can_merge: canMerge,
        can_print_multiple: canPrintMultiple
      },
      salesItem,
      close
    } = this.props;
    const {
      mergeItems,
      obtainedFrom,
      printMultiple,
      sellersContractNumber
    } = this.state;

    const obtainedFromId =
      obtainedFrom.id && obtainedFrom.type !== "other"
        ? `&obtained_from_id=${obtainedFrom.id}`
        : "";
    const obtainedFromType = obtainedFrom.type
      ? `&obtained_from_type=${obtainedFrom.type}`
      : "";
    const boxFreeObtainedFromOtherText =
      obtainedFrom.type === "other"
        ? `&obtained_from_text=${obtainedFrom.text}`
        : "";
    const merge = mergeItems ? "&merge_items=true" : "";
    const multiple = printMultiple ? "&multiple=true" : "";

    const url = `${API_BASE}/sales_order_line_items/${salesItem.id}/download_certificate_of_conformance?sellers_contract_number=${encodeURIComponent(
      sellersContractNumber
    )}${obtainedFromId}${obtainedFromType}${merge}${boxFreeObtainedFromOtherText}${multiple}`;

    const canDownload =
      obtainedFrom.type !== "other" ||
      (obtainedFrom.type === "other" && !_.isEmpty(obtainedFrom.text));

    return (
      <React.Fragment>
        <AgnosticLoader fetch={this.fetch} id={salesItem.inventory_id}>
          {({ loading }) => (
            <DataTable loading={loading} loadingRows={1}>
              <DataTable.Head>
                <th />
                <th />
                <th>Code</th>
                <th>Company Name</th>
              </DataTable.Head>
              <DataTable.Body>
                {this.state.inventory.purchase_order_line_items
                  .map(this.renderPORow)
                  .concat(
                    this.state.inventory.sales_order_line_items
                      .filter(s => s.exchange_sale && s.id !== salesItem.id)
                      .map(this.renderSORow)
                  )
                  .concat(
                    this.state.inventory.repair_order_line_items.map(
                      this.renderRORow
                    )
                  )}
                <tr>
                  <td />
                  <td className="text-center">
                    <input
                      type="radio"
                      name="obtained_from_id"
                      className="radio-inline"
                      checked={obtainedFrom.type === "other"}
                      onChange={this.onFlatItemSelected}
                    />
                  </td>
                  <td>Other</td>
                  <td>
                    <input
                      ref={this.inputRef}
                      type="text"
                      name="obtained_from_text"
                      className="form-control"
                      defaultValue={obtainedFrom.text}
                      disabled={obtainedFrom.type !== "other"}
                      onChange={this.onObtainedFromOther}
                      required={obtainedFrom.type === "other"}
                    />
                  </td>
                </tr>
              </DataTable.Body>
            </DataTable>
          )}
        </AgnosticLoader>
        {canMerge && (
          <Warning enableIcon={false}>
            Multiple units belong to the same PN {salesItem.part.part_number}{" "}
            and have the same Tag, Trace and Condition information.
          </Warning>
        )}
        <FormRow>
          <Col md={4}>
            <div className="form-group">
              <label
                className="control-label"
                htmlFor="sellers_contract_number"
              >
                Seller&apos;s Contract #:
              </label>
              <input
                type="text"
                name="sellers_contract_number"
                className="form-control"
                value={sellersContractNumber}
                onChange={this.onSellersContractUpdated}
              />
            </div>
          </Col>
          {canMerge && (
            <Col md={4}>
              <CheckGroup title="Do You Want To Merge To 1 CoC?" justified>
                <label
                  className={`btn btn-default ${mergeItems && "active"}`}
                  htmlFor="merge_items"
                >
                  <input
                    type="checkbox"
                    id="merge_items"
                    checked
                    onChange={() =>
                      this.setState({
                        mergeItems: !mergeItems,
                        printMultiple: false
                      })}
                  />
                  <i className="fa fa-lg fa-check-circle" />
                  &nbsp;&nbsp;Merge CoC
                </label>
              </CheckGroup>
            </Col>
          )}
          {canPrintMultiple && (
            <Col md={4}>
              <CheckGroup title="Print All?" justified>
                <label
                  className={`btn btn-default ${printMultiple && "active"}`}
                  htmlFor="print_multiple"
                >
                  <input
                    type="checkbox"
                    id="print_multiple"
                    checked
                    onChange={() =>
                      this.setState({
                        printMultiple: !printMultiple,
                        mergeItems: false
                      })}
                  />
                  <i className="fa fa-lg fa-check-circle" />
                  &nbsp;&nbsp;Print All
                </label>
              </CheckGroup>
            </Col>
          )}
        </FormRow>
        <div className="clearfix">
          <button
            className="pull-right btn btn-primary"
            disabled={!canDownload}
            onClick={() => {
              window.open(url, "_blank");
              close();
            }}
          >
            <span>&nbsp;Download CoC/s </span>
          </button>
        </div>
      </React.Fragment>
    );
  }
}

const withPermissions = dataManager("permissions", async ({ salesItem }) => {
  const { data: permissions } = await api.salesOrders.lineItems.cocPermissions(
    salesItem.id
  );
  return permissions;
});

export default withRouter(withPermissions(Form));



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/DownloadCoC/Form.jsx